export default __webpack_public_path__ + "static/media/10-22_As.42cf608f.svg";